/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react';
import Typography from '@material-ui/core/Typography';
// TODO: remove below when email sending is sorted out
import { Link as RouterLink } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';

import type { SendVerificationEmailDto } from 'state/signUpSteps';
import LoadingButton from 'components/LoadingButton';
import type { StepComponentProps } from 'components/Stepper';
// TODO: remove below when email sending is sorted out
import { useRefSize } from 'components/shared/hooks';

import useStyles from './VerifyAccount.style';

type VerifyAccountProps = StepComponentProps & {
  currentUser: string | null;
  // TODO: remove once email sending is sorted out
  verificationToken: string | null;
  sendVerificationEmail: (
    sendVerificationEmail: SendVerificationEmailDto
  ) => void;
};

const VerifyAccount: React.FC<VerifyAccountProps> = ({
  pending,
  verificationToken,
  currentUser,
  sendVerificationEmail,
}) => {
  const { header, subheader, body, email, resendEmailButton } = useStyles();

  const resendEmail = (_event: React.MouseEvent<HTMLButtonElement>) =>
    sendVerificationEmail({ username: currentUser });

  // TODO: remove once email sending is sorted out
  useEffect(() => {
    sendVerificationEmail({ username: currentUser });
  }, [currentUser, sendVerificationEmail]);
  const typographyRef = useRef<HTMLElement>(null);
  const spinnerSize = typographyRef.current
    ? window.getComputedStyle(typographyRef.current).fontSize
    : undefined;
  // /////////////////////////////////////////////

  return (
    <>
      <Typography variant="h2" className={header}>
        Thank you for registering
      </Typography>
      {/* TODO: remove when email sending is sorted out */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Typography variant="body2" className={body} ref={typographyRef}>
          Please click the link to verify your account:&nbsp;
        </Typography>
        <div style={{ marginBottom: '16px', display: 'flex' }}>
          {verificationToken && currentUser ? (
            <RouterLink
              className={email}
              to={`/signup?verify=${verificationToken}&username=${btoa(
                currentUser
              )}`}
            >
              Verify Account
            </RouterLink>
          ) : (
            <CircularProgress
              size={spinnerSize}
              title="loading spinner"
              aria-hidden
            />
          )}
        </div>
      </div>
      {/* ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ */}
      {/*
       * <Typography variant="body2" className={subheader}>
       *   You will receive an email from bittitansupport@bittitan.com with a link
       *   to confirm your email address and set up a password.
       * </Typography>
       * <Typography variant="body2" className={body}>
       *   An email has been sent to&nbsp;
       *   <span className={email}>{currentUser}</span>
       * </Typography>
       * <LoadingButton
       *   variant="outlined"
       *   color="primary"
       *   onClick={resendEmail}
       *   className={resendEmailButton}
       *   pending={!!pending}
       * >
       *   Resend Email
       * </LoadingButton>
       */}
    </>
  );
};

export default VerifyAccount;
